<template>
  <j-select-biz-component :width="1000" v-bind="configs" v-on="$listeners"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectUser',
    components: { JSelectBizComponent },
    props:{
      //'value','option','appId',"disabled"
      value: {
        type: String,
        default: ''
      },
      url:{
        type:String,
        default:'/sys/user/list'
      },
      rowKey:{
        type:String,
        default:'id'
      },
      // 是否显示排序按钮，默认 false
      isSort: {
        type: Boolean,
        default: false
      },
      // 需要排序的數據
      sortItem: {
        type: Object,
      },
    },
    data() {
      return {
        settings: {
          name: this.$store.getters.language['depart.management.deportDirector'],
          displayKey: "realname",
          rowKey:this.rowKey,
          returnKeys: ['id', 'workNo'],
          listUrl: this.url,
          queryParamCode: 'username',
          queryParamText: this.$store.getters.language['user.column.userAccount'],
          isSort: this.isSort,
          sortItem: this.sortItem,
          columns: [
            { title: this.$store.getters.language['user.column.userAccount'], dataIndex: 'username', align: 'center', width: '25%', widthRight: '70%' ,customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            { title: this.$store.getters.language['user.column.workNo'], dataIndex: 'workNo', align: 'center', width: '25%' ,
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            { title: this.$store.getters.language['user.column.realname'], dataIndex: 'realname', align: 'center', width: '25%' ,
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            { title: this.$store.getters.language['user.column.phone'], dataIndex: 'phone', align: 'center', width: '25%' }
          ]
        }
      }
    },
    computed: {
      configs() {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    },
    // methods: {
    //   handleSortOk(id, userCodes, userNames) {
    //     this.$emit('handleSortOk', id, userCodes, userNames)
    //   }, 
    // }
  }
</script>

<style lang="less" scoped></style>